import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { PatentDrawingDataForm } from '../_models/patent-drawing-data-form';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class PatentDrawingService {

  constructor(private http: HttpClient, private authService : AuthService) { }


  public static readonly URL_PATENTDRAWING_CONTROLLER = environment.apiUrl + '/patentDrawing/';

  public static readonly URL_SAVEANDUPDATE_PATENTDRAWING = PatentDrawingService.URL_PATENTDRAWING_CONTROLLER + "saveUpdate/";
  public static readonly URL_PATENTDRAWING_LIST = PatentDrawingService.URL_PATENTDRAWING_CONTROLLER + "getAll/";
  public static readonly URL_PATENTDRAWING_BY_PROJECTID = PatentDrawingService.URL_PATENTDRAWING_CONTROLLER + "getByProectId/";
  public static readonly URL_SAVEANDUPDATEWITHFILE_PATENTDRAWING = PatentDrawingService.URL_PATENTDRAWING_CONTROLLER + "saveUpdateWithFile/";


  saveAndUpdate(patentDrawingDataForm: PatentDrawingDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentDrawingService.URL_SAVEANDUPDATE_PATENTDRAWING + userToken,patentDrawingDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  uploadInventionDrawing(patentDrawingDataForm: PatentDrawingDataForm, file: File): Observable<HttpEvent<{}>> {
    const userToken: string = this.authService.getUserToken();
    const formdata: FormData = new FormData();
    formdata.append('file', file);
    formdata.append('documentUploadForm', JSON.stringify(patentDrawingDataForm));

    const req = new HttpRequest('POST', PatentDrawingService.URL_SAVEANDUPDATEWITHFILE_PATENTDRAWING + '/' + userToken, formdata, {
      reportProgress: true, 
      responseType: 'text',
    });
    return this.http.request(req)
     .pipe(catchError(this.handleError('Request Failed')));
    // return this.http.post(PatentDrawingService.URL_SAVEANDUPDATE_PATENTDRAWING + '/' +  userToken, formdata,{}
    // .pipe(catchError(this.handleError('Request Failed')));
  }


  getPatentDrawingList() {
    let userToken: string = this.authService.getUserToken();
    return this.http.get(PatentDrawingService.URL_PATENTDRAWING_LIST + userToken)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  
  getPatentDrawingByPojectId(projectId) {
  let userToken: string = this.authService.getUserToken();
  return this.http.post(PatentDrawingService.URL_PATENTDRAWING_BY_PROJECTID +projectId + '/'+userToken,projectId)
    .pipe(catchError(this.handleError('Request Failed')));
}


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }

}
